if (!customElements.get('countdown-timer')) {
  const UNITS = ['days', 'hours', 'minutes', 'seconds'];

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      const parts  = (this.dataset.date || '').split('-');
      const day    = parseInt(parts[0], 10);
      const month  = parseInt(parts[1], 10);
      const year   = parseInt(parts[2], 10);
      const time   = (this.dataset.time || '').split(':');
      const hour   = time.length > 1 ? parseInt(time[0], 10) : 0;
      const minute = time.length > 1 ? parseInt(time[1], 10) : 0;

      this.countDownDate = [day, month, year, hour, minute].some(isNaN)
        ? NaN
        : new Date(year, month - 1, day, hour, minute, 0, 0).getTime();
    }

    connectedCallback() {
      if (isNaN(this.countDownDate)) {
        console.warn('[countdown-timer] missing or invalid data-date; timer disabled', this);
        return;
      }

      this.num = {};
      this.col = {};
      this.prev = {};
      UNITS.forEach((unit) => {
        this.col[unit] = this.querySelector('.' + unit);
        this.num[unit] = this.col[unit]
          ? this.col[unit].querySelector('.countdown-timer--column--number')
          : null;
      });

      if (!UNITS.some((u) => this.num[u])) return;

      this.tick();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    tick() {
      const distance = this.countDownDate - Date.now();

      if (distance <= 0) {
        this.expire();
        return;
      }

      this.render({
        days:    Math.floor(distance / 864e5),
        hours:   Math.floor((distance % 864e5) / 36e5),
        minutes: Math.floor((distance % 36e5) / 6e4),
        seconds: Math.floor((distance % 6e4) / 1e3)
      });

      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.tick(), 1000 - (Date.now() % 1000));
    }

    render(values) {
      UNITS.forEach((unit) => {
        const value = values[unit];
        if (value === this.prev[unit]) return;

        if (this.num[unit]) {
          this.num[unit].textContent = CountdownTimer.addZero(value);
        }
        if (this.col[unit]) {
          if (this.prev[unit] !== undefined) {
            this.col[unit].classList.remove('count-' + this.prev[unit]);
          }
          this.col[unit].classList.add('count-' + value);
        }
        this.prev[unit] = value;
      });
    }

    expire() {
      clearTimeout(this.timer);
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      const row = this.closest('div.row');
      if (row) row.remove();
    }

    static addZero(x) {
      return x;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}